import React from 'react';
import { motion } from 'framer-motion';
import { Moon, Star, ChevronRight } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-warm-white py-16 md:py-24 px-4 relative overflow-hidden" data-id="element-112">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-113">
        <div className="absolute top-10 left-10 text-gold/20" data-id="element-114">
          <Star size={40} data-id="element-115" />
        </div>
        <div className="absolute top-40 right-20 text-sky/20" data-id="element-116">
          <Moon size={60} data-id="element-117" />
        </div>
        <div className="absolute bottom-20 left-1/4 text-lavender/30" data-id="element-118">
          <Star size={30} data-id="element-119" />
        </div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="inline-flex items-center gap-2 bg-navy/5 text-navy px-4 py-2 rounded-full text-sm font-semibold mb-8" data-id="element-121">
          <span className="text-gold" data-id="element-122">✨</span> Para madres y padres de bebés de
          4 a 24 meses
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="text-4xl md:text-5xl lg:text-6xl font-bold text-navy leading-tight mb-6" data-id="element-123">
          ¿Tu bebé no duerme bien y ya no sabés qué más hacer?
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="text-lg md:text-xl text-navy/80 mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-124">
          Descubrí el sistema completo que ayuda a madres y padres agotados a
          entender por qué su bebé no descansa bien, corregir los errores que
          arruinan la noche y aplicar una rutina clara para empezar a ver
          cambios reales desde las primeras noches.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="text-xl md:text-2xl font-semibold text-navy mb-10" data-id="element-125">
          Más sueño. Menos llanto. Menos confusión. Más paz para toda la casa.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="flex flex-col items-center" data-id="element-126">
          <a href="#compra" className="bg-navy hover:bg-navy-light text-white text-lg md:text-xl font-bold py-4 px-8 rounded-full shadow-soft transition-all transform hover:scale-105 flex items-center gap-2 w-full md:w-auto justify-center" data-id="element-127">
            👉 QUIERO ACCEDER AHORA AL MÉTODO NOCHES DE PAZ™
          </a>
          <p className="text-sm text-navy/60 mt-4 font-medium" data-id="element-128">
            Acceso inmediato · Formato PDF · Lo recibís en minutos
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.5,
        duration: 0.5
      }} className="mt-16 relative max-w-2xl mx-auto" data-id="element-129">
          <a href="#compra" className="block cursor-pointer group" data-id="element-130">
            <div className="absolute inset-0 bg-sky/20 rounded-2xl transform rotate-2 group-hover:rotate-3 transition-transform" data-id="element-131"></div>
            <img src="https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=800&q=80" alt="Método Noches de Paz - Libro Digital" className="relative rounded-2xl shadow-2xl w-full object-cover aspect-[4/3] group-hover:-translate-y-1 transition-transform" data-id="element-132" />
            <div className="absolute inset-0 bg-navy/10 rounded-2xl group-hover:bg-transparent transition-colors" data-id="element-133"></div>
          </a>
        </motion.div>
      </div>
    </section>;
}